"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const FormModal_1 = require("../components/FormModal");
function useFormModal({ title, fields, description, submitText = 'Submit', size, }) {
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [values, setValues] = react_1.useState(defaultValues(fields));
    const formActions = react_1.useRef(null);
    const modal = react_1.useMemo(() => (jsx_runtime_1.jsx(FormModal_1.FormModal, { description: description, title: title, submitText: submitText, isOpen: isOpen, fields: fields, onSubmit: () => { var _a, _b; return (_b = (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.submit) === null || _b === void 0 ? void 0 : _b.call(_a, values); }, onDismiss: () => { var _a, _b; return (_b = (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 ? void 0 : _b.call(_a); }, values: values, setValues: setValues, size: size }, void 0)), [description, title, submitText, isOpen, fields, values, size]);
    const trigger = react_1.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        setValues(defaultValues(fields));
        setIsOpen(true);
        return new Promise((resolve, reject) => {
            formActions.current = {
                submit: values => {
                    setIsOpen(false);
                    formActions.current = null;
                    resolve(internalValuesToResult(fields, values));
                },
                reject: () => {
                    setIsOpen(false);
                    formActions.current = null;
                    reject(new Error('Form was dismissed.'));
                },
            };
        });
    }), [fields]);
    const dismiss = react_1.useCallback(() => {
        var _a, _b;
        (_b = (_a = formActions.current) === null || _a === void 0 ? void 0 : _a.reject) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    return react_1.useMemo(() => [modal, trigger, { dismiss }], [dismiss, modal, trigger]);
}
exports.useFormModal = useFormModal;
function defaultValues(fields) {
    return lodash_1.mapValues(fields, field => { var _a; return (_a = field.defaultValue) !== null && _a !== void 0 ? _a : null; });
}
function internalValuesToResult(fields, values) {
    return lodash_1.mapValues(fields, ({ type }, key) => {
        const value = values[key];
        if (type === 'number' || type === 'timestamp') {
            return Number(value);
        }
        return value;
    });
}
//# sourceMappingURL=useFormModal.js.map